import { useIsAuthenticated } from "hooks/useAuth"


export const AuthenticatedTemplate = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  return isAuthenticated ? children : null;
}
export const UnauthenticatedTemplate = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  return isAuthenticated ? null :children;
}